import { CSSProperties } from "react";
import { colors } from "../theme/colors";

interface LoginStyles {
  container: CSSProperties;
  logoBox: CSSProperties;
  logo: CSSProperties;
  heading: CSSProperties;
  label: CSSProperties;
  input: CSSProperties;
  passwordInput: CSSProperties;
  field: CSSProperties;
  error: CSSProperties;
  button: CSSProperties;
  pageBG: CSSProperties;
  forgotPasswordLink: CSSProperties;
  backLink: CSSProperties;
  backButton: CSSProperties;
  success: CSSProperties;
  instruction: CSSProperties;
}

const loginStyles: LoginStyles = {
  pageBG: {
    background: colors.secondary,
    minHeight: "100vh",
    width: "100vw",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    width: 400,
    // margin: "40px auto",/
    padding: 32,
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    background: colors.white,
  },
  logoBox: {
    display: "flex",
    flexDirection: "column" as CSSProperties["flexDirection"],
    alignItems: "center",
    marginBottom: 24,
  },
  logo: {
    width: 150,
    height: 150,
    objectFit: "contain",
    marginBottom: 16,
  },
  heading: {
    fontFamily: "'Inter', sans-serif",
    textAlign: "center",
    fontWeight: 600,
    fontSize: 20,
    color: colors.text,
  },
  label: {
    display: "block",
    marginBottom: 6,
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    color: colors.darkGray,
    fontWeight: 500,
  },
  input: {
    width: "95%",
    padding: 10,
    border: "1px solid #ccc",
    fontFamily: "'Inter', sans-serif",
    borderRadius: 4,
    color: colors.text,
    fontSize: 16,
  },
  instruction: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    color: colors.darkGray,
    textAlign: "center" as CSSProperties["textAlign"],
    marginBottom: 16,
  },
  passwordInput: {
    letterSpacing: 2,
  },
  field: {
    marginBottom: 20,
  },
  error: {
    color: "#C62828",
    background: "#FFECEC",
    border: "1px solid #E53935",
    borderRadius: 6,
    padding: 10,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  button: {
    width: "100%",
    padding: 12,
    fontFamily: "'Inter', sans-serif",
    background: "#2E7D32",
    color: "#FFFFFF",
    border: "none",
    borderRadius: 6,
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: 1,
    cursor: "pointer",
    marginTop: 8,
  },
  forgotPasswordLink: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 16,
  },
  backLink: {
    display: "flex",
    justifyContent: "center",
    marginTop: 16,
  },
  backButton: {
    background: "none",
    border: "none",
    color: "#2E7D32",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    textDecoration: "underline",
  },
  success: {
    color: "#2E7D32",
    background: "#E8F5E9",
    border: "1px solid #81C784",
    borderRadius: 6,
    padding: 10,
    marginTop: 16,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
};

export default loginStyles;
